<template>
  <div class="add-pin-marker">
    <LMarker
      class="add-pin-marker-leaflet"
      :lat-lng="pins.newPin.data.coordinates"
      :draggable="true"
    >
      <LPopup
        :autoclose="false"
        class="newpin-popup-content"
        :permanent="true"
        :keep-in-view="true"
        :keepInView="true"
      >
        <AddPinMarkerConfirmButton/>
      </LPopup>
      <LIcon
        :popup-anchor="popupAnchor"
        :icon-size="dimensions.size"
        :icon-anchor="dimensions.anchor"
      >
        <div v-bind:class="pins.newPin.data.color" class="bumpmap-marker newpin">
          <div class="newpin-wrapper animated infinite pulse">
            <AddPinMarkerIcon/>
          </div>
        </div>
      </LIcon>
    </LMarker>
  </div>
</template>

<script>
import { LPopup, LMarker, LIcon } from 'vue2-leaflet'
import { mapState } from 'redux-vuex'
import { dispatch } from '@/state'
import AddPinMarkerIcon from '@/components/home/marker/AddPinMarkerIcon.vue'
import AddPinMarkerConfirmButton from '@/components/home/marker/AddPinMarkerConfirmButton.vue'

export default {
  name: 'AddPinMarker',
  props: ['dimensions'],
  components: {
    LMarker,
    LIcon,
    LPopup,
    AddPinMarkerIcon,
    AddPinMarkerConfirmButton,
  },
  data: mapState('pins', 'explorer'),
  computed: {
    popupAnchor() {
      return [0.5 * this.dimensions.size[0], 0 - 0.25 * this.dimensions.size[1]]
    },
  },
}
</script>

<style lang="scss">
.newpin-popup-content,
.newpin-tooltip-content {
  padding: 10px;
}
.newpin-popup-content {
  display: flex;
  width: 100%;
  pointer-events: none;
  font-size: 1.5em;
  text-align: center;
  justify-content: center;
}

.bumpmap-marker.newpin {
  pointer-events: auto;
}
</style>
